import { render, staticRenderFns } from "./hyxw.vue?vue&type=template&id=4edd9e9b&scoped=true&"
import script from "./hyxw.vue?vue&type=script&lang=js&"
export * from "./hyxw.vue?vue&type=script&lang=js&"
import style0 from "./hyxw.vue?vue&type=style&index=0&id=4edd9e9b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4edd9e9b",
  null
  
)

export default component.exports